module.exports = __webpack_public_path__ + "img/meditation_100.af8b908e.svg";